var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAdBirthControl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 18.89a4.56 4.56 0 0 1-2.322-.63 4.302 4.302 0 0 1-2.03-2.717A4.178 4.178 0 0 1 1.6 12.3l5.767-9.042c1.289-2.022 4.045-2.66 6.143-1.422a4.302 4.302 0 0 1 2.028 2.716 4.177 4.177 0 0 1-.55 3.245l-5.766 9.041c-.845 1.323-2.317 2.054-3.821 2.054Zm5.78-16.616c-1.148 0-2.268.555-2.909 1.56l-5.767 9.043a3.111 3.111 0 0 0-.411 2.416 3.24 3.24 0 0 0 1.53 2.042c1.606.948 3.711.465 4.692-1.075l5.767-9.042a3.11 3.11 0 0 0 .412-2.416 3.24 3.24 0 0 0-1.53-2.042 3.506 3.506 0 0 0-1.784-.486Z",
    fill: "#2FAEF3",
    stroke: "#2FAEF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.208 7.604-.545.925 6.716 3.961.545-.924-6.716-3.962Z",
    fill: "#2FAEF3",
    stroke: "#2FAEF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.212 20.52c-.445 0-.896-.064-1.342-.2-5.237-1.636-11.551-3.642-11.908-3.909l.321-.43.275-.46c.511.262 7.404 2.454 11.628 3.774 1.792.546 3.71-.405 4.276-2.122a3.104 3.104 0 0 0-.196-2.42 3.334 3.334 0 0 0-2.015-1.654L12.737 9.892l.313-1.026 10.514 3.206a4.4 4.4 0 0 1 2.655 2.187 4.172 4.172 0 0 1 .263 3.25c-.605 1.836-2.373 3.012-4.27 3.012Z",
    fill: "#2FAEF3",
    stroke: "#2FAEF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m17.642 10.814-2.384 7.221 1.02.337 2.383-7.222-1.02-.336Z",
    fill: "#2FAEF3",
    stroke: "#2FAEF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdBirthControl);
export default __webpack_public_path__ + "static/media/icon-ad-birth-control.0ffbbe5cc8570bcf65c8e609012e9831.svg";
export { ForwardRef as ReactComponent };